<script>
export default {
  name: "DidoCatalog500",
};
</script>

<script setup>
import { inject } from "vue";

// inject route and method for updating route from root component
const setCurrentRouteFromUrl = inject("setCurrentRouteFromUrl");

const goToHome = () => {
  window.history.pushState(null, "DidoExplore", "?page=explore");
  setCurrentRouteFromUrl();
};
</script>

<template>
  <div class="q-pa-md bg-white text-secondary row-all-center text-center">
    <div>
      <div class="dido-catalogue-500-subtitle text-h2">
        Serveur indisponible
      </div>

      <div class="q-mt-md text-h6 text-black">
        Merci d'essayer à nouveau plus tard
      </div>

      <QBtn
        class="q-mt-xl"
        color="secondary"
        text-color="white"
        unelevated
        label="Accueil"
        no-caps
        icon="mdi-home"
        @click="goToHome"
      />
    </div>
  </div>
</template>

<style lang="sass" scoped>
.dido-catalogue-500-subtitle
  opacity:.7
</style>
